import Utils from '../../common/Utils';

/**
 * NctvTempl Template
 * @category testApp
 */
class NctvTempl {
	/**
	 * Sub1 Templ
	 * @param  {Object} _d={}
	 */
	static getTempl(_d={}, _nctvUrl='') {

		const randomIds = NctvTempl.getRandom(_d.NctvList.length);
		// NCTV 리스트 중 랜덤으로 2개만 뿌려짐
		// console.log('NctvTempl.js _d: ', _d);
		// console.log ( 'NctvTempl.random() : ', randomIds );

		return `
			<header class="card-title">
				<h2 class="title">${_d.NctvTitle.title}</h2>
			</header>
			<ul class="card-list" id="cardTypeNctv">
				${_d.NctvList.map( (item, index) => {
					return NctvTempl.itemTempl(item, _nctvUrl);
					// if(NctvTempl.sameNum(randomIds, index)) return NctvTempl.itemTempl(item, _nctvUrl);
				}).join('')}
			</ul>
        `;
	}

	static getRandom(_max) {
			let random = [];
			for(var i=0; i<2; i++) {
				let n = Math.floor(Math.random() * _max);
				if(! NctvTempl.sameNum(random,n)) {
					random.push(n);
				} else {
					i--;
				}
			}
			return random;
	}
	static sameNum (random, n) {
		for (var i = 0; i < random.length; i++) {
			if (n === random[i]) {
				return true;
			}
		}
		return false;
		// return random.find((e) => (e === n));
	}

	static itemTempl(_d, _nctvUrl){
		return `
    	<li class="card-item">
			<a class="card-link" href="${_nctvUrl}/view?tv=bns&id=${_d.id}">
				<div class="thumb" style="background-image:url(${_d.thumbnail})"><span class="icon-vodplay"></span></div>
				<div class="info">
					<h3 class="subject">${_d.title}</h3>
					<p class="desc">${_d.channelName}</p>
				</div>
			</a>
		</li>`;
	}


} // end of class

export default NctvTempl;